import React from 'react';
import { IconProps } from '../types';

const AddUserIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  const aspectRatio = 1304 / 1024; // ~1.27 from reference SVG
  const width = size;
  const height = size / aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1304 1024"
      fill={color}
      className={className}
    >
      <path d="M827.809702 473.06979C958.501162 473.06979 1064.344595 366.935006 1064.344595 236.534896 1064.344595 105.843435 958.501162 0 827.809702 0 697.118241 0 591.274806 105.843435 591.274806 236.534896 591.274806 366.935006 697.118241 473.06979 827.809702 473.06979L827.809702 473.06979ZM295.637403 354.823154 295.637403 177.432388 177.390766 177.432388 177.390766 354.823154 0 354.823154 0 473.06979 177.390766 473.06979 177.390766 650.460557 295.637403 650.460557 295.637403 473.06979 473.02817 473.06979 473.02817 354.823154 295.637403 354.823154 295.637403 354.823154ZM827.809702 591.358049C670.230762 591.358049 354.73991 670.314004 354.73991 827.892945L354.73991 946.139583 1300.87949 946.139583 1300.87949 827.892945C1300.87949 670.314004 985.388637 591.358049 827.809702 591.358049L827.809702 591.358049Z" />
    </svg>
  );
};

export default AddUserIcon;
